<template>
  <div class="">
    Код модели:
    <span class="color-gray">
      {{
        getSelectedOffer?.kod_torgovogo_predlozheniya ??
        getSelectedProduct?.productCode + "-001"
      }}
    </span>
  </div>
</template>

<script>
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";

export default {
  name: "OfferCode",
  setup() {
    const store = useProductStore();

    return {
      store,
    };
  },
  computed: {
    ...mapState(useProductStore, [
      "getSelectedOffer",
      "getSelectedProduct",
      "isEmptyOffers",
    ]),
  },
};
</script>
